import { EntityType, NewsfeedProperties } from '../../models';
import { NewsfeedFilterDto, NewsfeedPromotesDto } from '../common-dto';
import { MediaRequestDto } from '../request-dto';

import { MediaResponseDto } from './media-response.dto';

export interface NewsfeedResponseDto {
  id: string;
  title: string;
  isPinned: boolean;
  isCollapsed: boolean;
  isPublished: boolean;
  type: EntityType;
  referenceId: string;
  referenceCreatedByUserId: string;
  publishedAtUtc: string;
  expirationAtUtc: string;
  createdAtUtc: string;
  updatedAtUtc: string;
  references?: NewsfeedItemResponseDto[];
  promoteReferences?: NewsfeedPromotesDto;
  filterSettings?: NewsfeedFilterDto[];
  properties?: NewsfeedProperties;
  newsfeedType: NewsfeedType;
  // custom selected media
  media: MediaResponseDto;
}

export interface NewsfeedAddRequestDto {
  type: EntityType;
  referenceId: string;
  isCollapsed: boolean;
  publishedAtUtc: string;
  expirationAtUtc: string;
  promoteReferences?: NewsfeedPromotesDto;
  filterSettings?: NewsfeedFilterDto[];
  properties?: NewsfeedProperties;
  newsfeedType: NewsfeedType;
  media?: MediaRequestDto;
}

export interface NewsfeedItemResponseDto {
  id: string;
  name: string;
  type: string;
  description: string;
  media: MediaResponseDto;
}

export interface NewsfeedResponseDtoPageResponseDto {
  items: NewsfeedResponseDto[];
  total: number;
}

export enum NewsfeedType {
  Spotlight = 'spotlight',
  WelcomePromotion = 'welcomePromotion',
  LandingPage = 'landingPage',
}
